import { render, staticRenderFns } from "./ReferencesIndications.vue?vue&type=template&id=3e79878a&scoped=true"
import script from "./ReferencesIndications.vue?vue&type=script&lang=js"
export * from "./ReferencesIndications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e79878a",
  null
  
)

export default component.exports